class Accordion {
    constructor(selector) {
        this.buttons = document.querySelectorAll(selector);
        this.init();
    }

    init() {
        this.buttons.forEach((btn) => {
            const entry = btn.closest(".el-acc__entry");
            const panel = entry?.querySelector(".el-acc__entry__section");
            if (!panel) return;

            btn.setAttribute("aria-expanded", "false");
            panel.hidden = true;

            // Animations-Setup
            panel.style.overflow = "hidden";
            panel.style.height = "0px";
            panel.style.opacity = "0";

            btn.addEventListener("click", () => this.toggle(btn, panel));
        });
    }

    toggle(btn, panel) {
        const isOpen = btn.getAttribute("aria-expanded") === "true";
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (isOpen) {
            // CLOSE
            btn.setAttribute("aria-expanded", "false");

            if (reduceMotion) {
                panel.hidden = true;
                panel.style.height = "0px";
                panel.style.opacity = "0";
                return;
            }

            // 1) Aktuelle Höhe fixieren (wichtig, wenn gerade "auto")
            const start = panel.scrollHeight;
            panel.style.height = start + "px";
            panel.style.opacity = "1";

            // 2) nächsten Frame: auf 0 animieren
            requestAnimationFrame(() => {
                panel.style.height = "0px";
                panel.style.opacity = "0";
            });

            const onEnd = (e) => {
                if (e.propertyName !== "height") return;
                panel.hidden = true;
                panel.removeEventListener("transitionend", onEnd);
            };

            panel.addEventListener("transitionend", onEnd);
            return;
        } else {
            // OPEN
            btn.setAttribute("aria-expanded", "true");
            panel.hidden = false;

            if (reduceMotion) {
                panel.style.height = "auto";
                panel.style.opacity = "1";
                return;
            }

            // Startzustand
            panel.style.height = "0px";
            panel.style.opacity = "0";

            // Wichtig: erst reflow, dann Zielhöhe setzen
            panel.offsetHeight; // force reflow
            const target = panel.scrollHeight;

            panel.style.height = target + "px";
            panel.style.opacity = "1";

            const onEnd = (e) => {
                if (e.propertyName !== "height") return;
                panel.style.height = "auto"; // danach flexibel
                panel.removeEventListener("transitionend", onEnd);
            };
            panel.addEventListener("transitionend", onEnd);
        }
    }
}
